import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react';
import { className } from '@empori/util';
export function EmployeeCarousel(props) {
    var employees = props.employees;
    var _a = useState(0), activeIndex = _a[0], updateIndex = _a[1];
    var swiperParent = useRef(null);
    if (!employees) {
        return null;
    }
    useEffect(function () {
        swiperParent.current = document.querySelector('.progrits-employee-container');
    }, []);
    useEffect(function () {
        return;
    }, [activeIndex]);
    var setMargin = function (height) {
        if (window.innerWidth >= 800) {
            return;
        }
        var threshold = 520;
        if (!swiperParent.current) {
            swiperParent.current = document.querySelector('.progrits-employee-container');
        }
        if (swiperParent.current && height > threshold) {
            swiperParent.current.style.marginBottom = "".concat(height - threshold, "px");
        }
    };
    var slides = employees.filter(function (item) { return item.image && item.description; });
    var breakpoints = {
        0: {
            spaceBetween: 20
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Swiper, { spaceBetween: 0, onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); }, onSlideChangeTransitionEnd: function (swiper) { return setMargin(swiper.height); }, breakpoints: breakpoints, loop: true, autoHeight: true },
            React.createElement(PrevArrow, { activeIndex: activeIndex, totalSlides: slides.length }),
            slides.map(function (employee, index) {
                return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                    React.createElement(Slide, { employee: employee }));
            }),
            React.createElement(NextArrow, { activeIndex: activeIndex, totalSlides: slides.length }),
            React.createElement("div", { className: 'progrits-carousel-thumbnails element-flex' }, slides.map(function (employee, index) {
                return React.createElement(ThumbnailItem, { key: "slide-thumbnail-no-".concat(index + 1), index: index, activeIndex: activeIndex });
            })))));
}
function ThumbnailItem(props) {
    var swiper = useSwiper();
    return (React.createElement("div", { className: className('progrits-carousel-thumbnail-item', { active: props.activeIndex === props.index }), onClick: function () { return swiper.slideTo(props.index + 1); } },
        React.createElement("div", { className: 'index-indicator' },
            props.index <= 9 ? 0 : null,
            props.index + 1)));
}
function PrevArrow(props) {
    var swiper = useSwiper();
    return (React.createElement("div", { className: 'swiper-arrow swiper-prev' },
        React.createElement("div", { className: 'arrow', onClick: function () { return swiper.slidePrev(); } },
            React.createElement("i", { className: 'fa-light fa-arrow-left-long' })),
        React.createElement("div", { className: 'circle' })));
}
function NextArrow(props) {
    var swiper = useSwiper();
    return (React.createElement("div", { className: 'swiper-arrow swiper-next' },
        React.createElement("div", { className: 'arrow', onClick: function () { return swiper.slideNext(); } },
            React.createElement("i", { className: 'fa-light fa-arrow-right-long' })),
        React.createElement("div", { className: 'circle' })));
}
function Slide(props) {
    var employee = props.employee;
    var imgDims = { width: 400, height: 400 };
    var slide = useSwiperSlide();
    if (!employee) {
        return null;
    }
    return (React.createElement("div", { className: className('progrits-carousel-item element-flex', { active: slide.isActive }) },
        React.createElement("img", { className: 'progrits-carousel-image', src: "".concat(employee.image, "?width=").concat(imgDims.width, "&height=").concat(imgDims.height), width: imgDims.width, height: imgDims.height }),
        React.createElement("div", { className: 'progrits-carousel-info' },
            React.createElement("h3", { className: 'title' }, employee.name),
            React.createElement("div", { className: 'quote' }, "\"".concat(employee.quote, "\"")),
            React.createElement("div", { className: 'description' }, employee.description))));
}
